'use client';
import ThemeRegistry from '@/components/emotion/ThemeRegistry';
import AtomProvider from '@/components/jotai/AtomProvider';
import { SnackbarProvider } from 'notistack';
import React from 'react';
import ExternalScannerProvider from '@/components/ExternalScannerProvider';
import { FavoritesProvider } from '@/components/favorites/FavoritesProvider';
import UpdateAvailableBanner from '@/components/common/UpdateAvailableBanner';

export default function AppProviders({ children }: { children: React.ReactNode }): React.JSX.Element {
  const snackbarHideAfterSeconds = 10;
  return (
    <AtomProvider>
      <ThemeRegistry options={{ key: 'mui', prepend: false }}>
        <SnackbarProvider
          dense
          maxSnack={5}
          autoHideDuration={snackbarHideAfterSeconds * 1000}
          style={{ marginBottom: '20%' }}
        >
          <ExternalScannerProvider>
            <FavoritesProvider>
              <UpdateAvailableBanner />
              {children}
            </FavoritesProvider>
          </ExternalScannerProvider>
        </SnackbarProvider>
      </ThemeRegistry>
    </AtomProvider>
  );
}
